module.exports = __webpack_public_path__ + "img/image17.431b550b.png";